module.exports = __webpack_public_path__ + "static/media/refer.2fc7c5cf.png";